module.exports = __webpack_public_path__ + "img/Co2 Icons.df9893e2.png";